import { render, staticRenderFns } from "./PersonalSecurityPanel.vue?vue&type=template&id=324a5f34&scoped=true"
import script from "./PersonalSecurityPanel.vue?vue&type=script&lang=js"
export * from "./PersonalSecurityPanel.vue?vue&type=script&lang=js"
import style0 from "./PersonalSecurityPanel.vue?vue&type=style&index=0&id=324a5f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324a5f34",
  null
  
)

export default component.exports